import React from 'react';
import { Tooltip, Select } from '@firesoon/antd';
import { BackToPlatformFill } from '@firesoon/icons-react';

const { Option } = Select;

const Index = ({
  isSys,
  isMoreHospital,
  hideMultiCampusAll,
  logo,
  backText,
  hosName,
  hospitalInfoVos,
  hospitalId,
  onBackTo,
  onChangeHos,
}) => {
  const logoImg = <img src={logo} alt="logo" className="fs-logoIcon" />;

  if (isSys) {
    return logoImg;
  }

  return (
    <>
      <Tooltip placement="left" title={backText}>
        <BackToPlatformFill className="fs-back auto-track" onClick={onBackTo} data-log-value="返回应用平台" />
      </Tooltip>

      {logoImg}

      {isMoreHospital ? (
        // 多院区展示
        hospitalInfoVos.length > 0 ? (
          <Select
            style={{ width: 148, marginLeft: 16 }}
            className="fs-user-roles fs-hospitals"
            onChange={onChangeHos}
            value={hospitalId}
            dropdownClassName="fs-user-roles-drop"
            dropdownMatchSelectWidth={false}
          >
            {!hideMultiCampusAll && <Option value={-1}>全部院区</Option>}
            {hospitalInfoVos.map((item) => (
              <Option key={item.id} value={item.id} title={item.hospitalName} data-log-value="院区选择">
                {item.hospitalName}
              </Option>
            ))}
          </Select>
        ) : (
          ''
        )
      ) : (
        // 机构展示 目前仅在系统设置下会展示   院区展示：单个院区的情况下展示
        <span className="fs-hosName">{hosName}</span>
      )}
    </>
  );
};

export default Index;
